import axios from 'axios';
import { setAlert } from './alert';
import {
    GET_SECTOR,
    GET_ALL_SECTORS,
    GET_SECTOR_REQUEST,
    CREATE_SECTOR,
    UPDATE_SECTOR,
    DELETE_SECTOR,
    CLEAR_SECTOR,
    SECTOR_ERROR,
    SECTOR_LOADING
} from './types';

const API_URL = process.env.REACT_APP_SERVER_API_URL;

// Get all sectors
export const getSectors = () => async dispatch => {
    try {
        dispatch({ type: SECTOR_LOADING });
        
        const res = await axios.get(`${API_URL}/sectors`);
        if(res.data.success){
            dispatch({
                type: GET_ALL_SECTORS,
                payload: res.data.data
            });
        }else{
            dispatch( setAlert(res.data.error, 'danger') );
        }
    } catch (err) {
        dispatch({
            type: SECTOR_ERROR,
            payload: { msg: err.response?.statusText, status: err.response?.status }
        });
    }
};

// Get sectors by serviceable area
export const getSectorsByServiceableArea = (serviceableAreaId) => async dispatch => {
    try {
        dispatch({ type: SECTOR_LOADING });
        
        const res = await axios.get(`${API_URL}/sectors?serviceableArea=${serviceableAreaId}`);
        if(res.data.success){
            dispatch({
                type: GET_ALL_SECTORS,
                payload: res.data.data
            });
        }else{
            dispatch( setAlert(res.data.error, 'danger') );
        }
    } catch (err) {
        dispatch({
            type: SECTOR_ERROR,
            payload: { msg: err.response?.statusText, status: err.response?.status }
        });
    }
};

// Get sector by ID
export const getSector = (id) => async dispatch => {
    try {
        dispatch({ type: GET_SECTOR_REQUEST });
        
        const res = await axios.get(`${API_URL}/sectors/${id}`);
        if(res.data.success){
            dispatch({
                type: GET_SECTOR,
                payload: res.data.data
            });
        }else{
            dispatch( setAlert(res.data.error, 'danger') );
        };
    } catch (err) {
        dispatch({
            type: SECTOR_ERROR,
            payload: { msg: err.response?.statusText, status: err.response?.status }
        });
    }
};

// Create sector
export const createSector = (formData) => async dispatch => {
    try {
        dispatch({ type: SECTOR_LOADING });
        
        const config = {
            headers: {
                'Content-Type': 'application/json'
            }
        };
        
        const res = await axios.post(`${API_URL}/sectors`, formData, config);
        if(res.data.success){
            dispatch({
                type: CREATE_SECTOR,
                payload: res.data.data
            });
            dispatch(setAlert('Sector created successfully', 'success'));
        }else{
            dispatch(setAlert(res.data.error, 'danger'));
        }
    } catch (err) {
        const errors = err.response?.data?.errors;
        
        if (errors) {
            errors.forEach(error => dispatch(setAlert(error.msg, 'danger')));
        } else {
            dispatch(setAlert('Failed to create sector', 'danger'));
        }
        
        dispatch({
            type: SECTOR_ERROR,
            payload: { msg: err.response?.statusText, status: err.response?.status }
        });
        
        throw err;
    }
};

// Update sector
export const updateSector = (id, formData) => async dispatch => {
    try {
        dispatch({ type: SECTOR_LOADING });
        
        const config = {
            headers: {
                'Content-Type': 'application/json'
            }
        };
        
        const res = await axios.put(`${API_URL}/sectors/${id}`, formData, config);
        
        dispatch({
            type: UPDATE_SECTOR,
            payload: res.data.data
        });
        if(res.data.success){
            dispatch(setAlert('Sector updated successfully', 'success'));
        }else{
            dispatch(setAlert(res.data.error, 'danger'));
        }
        
        return res.data;
    } catch (err) {
        const errors = err.response?.data?.errors;
        
        if (errors) {
            errors.forEach(error => dispatch(setAlert(error.msg, 'danger')));
        } else {
            dispatch(setAlert('Failed to update sector', 'danger'));
        }
        
        dispatch({
            type: SECTOR_ERROR,
            payload: { msg: err.response?.statusText, status: err.response?.status }
        });
        
        throw err;
    }
};

// Delete sector
export const deleteSector = (id) => async dispatch => {
    try {
        dispatch({ type: SECTOR_LOADING });
        
        const res = await axios.delete(`${API_URL}/sectors/${id}`);
        
        dispatch({
            type: DELETE_SECTOR,
            payload: id
        });
        if(res.data.success){
            dispatch(setAlert('Sector deleted successfully', 'success'));
        }else{
            dispatch(setAlert(res.data.error, 'danger'));
        }
    } catch (err) {
        dispatch({
            type: SECTOR_ERROR,
            payload: { msg: err.response?.statusText, status: err.response?.status }
        });
        
        dispatch(setAlert('Failed to delete sector', 'danger'));
    }
};

// Clear sector
export const clearSector = () => dispatch => {
    dispatch({ type: CLEAR_SECTOR });
};
